import React from "react";

const View = ({ children }) => (
  <div className="graph_bottom_item">{children}</div>
);

export default View;